import { progressConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveProgress = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgress.replace(':recipientId', form.recipientId).replace(':progressId', form.id) :
            url.recipientProgresses.replace(':recipientId', form.recipientId),
        method: 'POST',
        body: form,
        request: () => ({ type: progressConstants.SAVING_PROGRESS_REQUEST }),
        success: (data) => ({ type: progressConstants.SAVING_PROGRESS_SUCCESS, data }),
        failure: (error) => ({ type: progressConstants.SAVING_PROGRESS_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0]} }),
        progress: {
            success: { message: () => 'Saved Progress.' }
        }
    }
});

export const deleteProgress = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgress.replace(':recipientId', recipientId).replace(':progressId', progressId),
        method: 'DELETE',
        request: () => ({ type: progressConstants.DELETE_PROGRESS_REQUEST }),
        success: (data) => ({ type: progressConstants.DELETE_PROGRESS_SUCCESS, data }),
        failure: (error) => ({ type: progressConstants.DELETE_PROGRESS_FAILURE, error }),
        formatData: () => (progressId),
        progress: {
            request: { message: () => 'Deleting progress' },
            success: { message: () => 'Deleted progress.' }
        }
    }
});

export const loadProgresses = (id) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgresses.replace(':recipientId', id),
        request: () => ({ type: progressConstants.LOAD_PROGRESS_REQUEST }),
        success: (data) => ({ type: progressConstants.LOAD_PROGRESS_SUCCESS, data }),
        failure: (error) => ({ type: progressConstants.LOAD_PROGRESS_FAILURE, error })
    }
});


// WEBPACK FOOTER //
// ./src/redux/actions/progress.actions.js